import React, { useState, createContext, useEffect } from "react";
import playlistsList from '../data/playlists.json';
import { getStorage, getReaded, getIndexLastSongPlayed } from "../data/storageManagement.js";

export const LOCAL_STORAGE_KEY_PROGRESS = "playlist-progress";
export const LOCAL_STORAGE_KEY_KEEP_PLAYING = "playlist-autoloop";

export const OptionsContext = createContext();

async function buildPlaylists() {
  const playlists = [];
  for (const playlistName of playlistsList) {
    try {
      const songs = await import(`../data/playlists/${playlistName}.js`);
      playlists.push({
        name: playlistName,
        songs: songs.default,
      });
    } catch (e) {
      console.error("Error loading songs for playlist:", playlistName, e);
    }
  }
  return playlists;
}

const extractIndexBaseOnFalse = (obj) => {
  // Au tout premier chargement (localStorage vierge), la playlist n'a pas encore
  // sa clé de progression : on repart d'une liste vide au lieu de planter.
  if (!Array.isArray(obj)) {
    return [];
  }
  return obj.reduce((res, value, index) => {
    if (value === false) {
      res.push(index);
    }
    return res;
  }, []);
}

const rand = (maximum) => {
  return Math.floor(Math.random() * maximum);
};

const getOneSongUnplayed = (namePlaylist) => {
  // sort un tableau indexé normalement a la taille du nombre de chanson de la playliste sélectionnée minus celle qui ont été jouée
  const allPlaylists = getReaded();
  const unreadSong = extractIndexBaseOnFalse(allPlaylists[namePlaylist]);
  // On pioche un numéro au hasard dans ce tableau
  const randomNumber = rand(unreadSong.length);
  if (!unreadSong.length) {
    return -1;
  }
  const songIndex = unreadSong[randomNumber];

  return songIndex;
}

export const returnGoodObject = (thekey, playlists) => {
  const playlist = playlists.find(pl => pl.name === thekey);
  // console.log('the key & playlists : ', thekey, playlists, playlist);
  return playlist ? playlist.songs : [];
}

export const OptionsProvider = (props) => {

  const theDefaultVolume = 0.6;
  const currentlyPlayed = getStorage();

  const [name, setName] = useState(playlistsList[0]);
  const lastIdPlayed = getIndexLastSongPlayed(name);

  const [playedTotal, setPlayedTotal] = useState(lastIdPlayed);
  const [indexOrder, setIndexOrder] = useState(playedTotal);
  const [playlists, setPlaylists] = useState([]);

  let currentlyPlay = returnGoodObject(name, playlists);

  let randomUnplayed = getOneSongUnplayed(name);

  const options = {
    audioLists: currentlyPlay,
    audioListStatus: currentlyPlayed[name],
    indexplay: randomUnplayed,
    defaultVolume: theDefaultVolume,
    currentVolume: theDefaultVolume,
  };

  const [params, setParams] = useState({
    ...options
  });

  useEffect(() => {
    buildPlaylists().then(loadedPlaylists => {
      setPlaylists(loadedPlaylists);
    });
  }, []);

  const updateStorageOncePlayed = (id) => {
    const storageRaw = getStorage();
    const storage = storageRaw[name];
    storage[id] = playedTotal;
    setPlayedTotal(prevPlayedTotal => prevPlayedTotal + 1);
    storageRaw[name] = storage;
    localStorage.setItem(LOCAL_STORAGE_KEY_PROGRESS, JSON.stringify(storageRaw));
    setParams((prev) => ({
      ...prev,
      ...{
        audioListStatus: storage,
      },
    }));
    setIndexOrder(indexOrder + 1);

    // currentlyPlayed = Object.values(getStorage())[0];
    return true;
  }

  const resetAudioListStatus = () => {
    const resetedPlaylist = Array(currentlyPlay.length).fill(false);
    setParams((prev) => ({
      ...prev,
      ...{
        indexplay: 0,
        audioListStatus: resetedPlaylist,
      },
    }));
    setPlayedTotal(0);
    setIndexOrder(0);
  }

  const setdatas = {
    params,
    setParams,
    updateStorageOncePlayed,
    getOneSongUnplayed,
    playedTotal,
    resetAudioListStatus,
    indexOrder,
    setIndexOrder,
    playlists,
    name,
    setName,
  };

  return (
    <OptionsContext.Provider value={setdatas}>
      {props.children}
    </OptionsContext.Provider>
  );
};
